(() => {
  const TOLERANCE = 20; // px

  function unlockButtons(root) {
    root
      .querySelectorAll('.slider-button[name="previous"], .slider-button[name="next"]')
      .forEach((b) => {
        b.disabled = false;
        b.removeAttribute('disabled');
        b.removeAttribute('aria-disabled');
      });
  }

  function handleMediaGalleryArrow(btn, e) {
    const gallery = btn.closest('media-gallery');
    if (!gallery) return false;

    // This is the thumbnails container used in Dawn
    const thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!thumbs) return false;

    const items = Array.from(thumbs.querySelectorAll('[data-target]'));
    if (!items.length) return false;

    // Find which thumbnail is currently active
    let currentIndex = items.findIndex((item) => item.querySelector('button[aria-current="true"]'));
    if (currentIndex === -1) currentIndex = 0;

    const name = btn.getAttribute('name'); // "next" or "previous"
    let nextIndex;

    if (name === 'next') {
      nextIndex = (currentIndex + 1) % items.length; // ✅ loops
    } else {
      nextIndex = (currentIndex - 1 + items.length) % items.length; // ✅ loops
    }

    const targetBtn = items[nextIndex]?.querySelector('button');
    if (!targetBtn) return false;

    // Prevent the theme slider click from only scrolling thumbnails
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // ✅ This updates the MAIN image (Dawn media-gallery listens to thumbnail button clicks)
    targetBtn.click();

    // Optional: ensure thumbnail strip scrolls so the active thumb stays visible
    const slider = thumbs.slider || thumbs.querySelector('.slider');
    if (slider && typeof slider.scrollTo === 'function') {
      slider.scrollTo({ left: items[nextIndex].offsetLeft, behavior: 'smooth' });
    }

    return true;
  }

  function onClick(e) {
    const btn = e.target.closest('.slider-button');
    if (!btn) return;

    const name = btn.getAttribute('name');
    if (name !== 'next' && name !== 'previous') return;

    // Always unlock (theme sometimes disables at ends)
    const root =
      btn.closest('media-gallery') ||
      btn.closest('slideshow-component') ||
      btn.closest('slider-component') ||
      btn.closest('.slider-mobile-gutter') ||
      document;

    unlockButtons(root);

    // ✅ If this is the product media-gallery, make arrows change the main image
    if (handleMediaGalleryArrow(btn, e)) return;

    // Otherwise do nothing (other sliders keep default behavior)
  }

  // keep buttons unlocked even if theme tries disabling them
  const mo = new MutationObserver(() => {
    document
      .querySelectorAll('media-gallery, slideshow-component, slider-component, .slider-mobile-gutter')
      .forEach(unlockButtons);
  });
  mo.observe(document.documentElement, {
    attributes: true,
    subtree: true,
    attributeFilter: ['disabled', 'aria-disabled'],
  });

  document.addEventListener('click', onClick, true);

  window.addEventListener('DOMContentLoaded', () => {
    document
      .querySelectorAll('media-gallery, slideshow-component, slider-component, .slider-mobile-gutter')
      .forEach(unlockButtons);
  });
})();
